<template>
  <div class="page page-contact">
    <div class="pagewrap">
      <div class="contact">
        <pre>{{ jsonResume }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
const PrismicConfig = require("@/prismic.config");
export const prismicEndpoint = PrismicConfig.apiEndpoint;
import * as $js from "package-js";
import { createResume } from "@/../createResume.js"

export default {
  name: "resume",
  data() {
    return {
      formattedResume: null,
      jsonResume: null,
      allWorkItems: null
    };
  },
  async created() {
    let allWorkItems = await $js.getAllDocs(prismicEndpoint);
    allWorkItems = allWorkItems.results
      .filter(doc => doc.type === "work_item")
      .map(workItem => {
        return { ...workItem.data, id: workItem.id };
      });
    this.allWorkItems = allWorkItems;
    $js
      .getSingleDocByType(prismicEndpoint, "resume", {
        fetchLinks: ["work_item.title", "work_item.highlight", "work_item.url"]
      })
      .then(res => {
        const formattedResume = $js.createPage(res);
        const jsonResume = createResume(allWorkItems, formattedResume);
        this.formattedResume = formattedResume;
        this.jsonResume = jsonResume;
      })
      .catch(err => {
        throw err;
      });
  }
};
</script>
<style scoped>
pre {
  padding: 1rem;
  color: white;
  background: black;
  overflow: scroll;
}
</style>
